import { jsx as i } from "react/jsx-runtime";
import { clsx as l } from "clsx";
import r from "./ProgressBar.module.css.js";
const t = ({ progress: a, height: e = 2, className: m }) => {
  const s = Math.min(Math.max(a, 0), 100);
  return (
    // biome-ignore lint/a11y/useFocusableInteractive: <explanation>
    /* @__PURE__ */ i(
      "div",
      {
        style: {
          height: `${e}px`,
          borderRadius: `${e}px`
        },
        role: "progressbar",
        "aria-label": "Progress bar",
        "aria-valuenow": s,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        className: l({
          [r.container]: !0,
          className: !!m
        }),
        children: /* @__PURE__ */ i(
          "div",
          {
            style: {
              height: `${e}px`,
              width: `${a}%`
            },
            className: l({
              [r.low]: a < 33,
              [r.medium]: a >= 33 && a < 66,
              [r.high]: a >= 66
            })
          }
        )
      }
    )
  );
};
t.displayName = "ProgressBar";
export {
  t as ProgressBar
};
//# sourceMappingURL=ProgressBar.js.map
